import { Component, Injector, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppComponentBase } from '../../app-component-base';
import { NotPaginatedTransportationPlans, TransportationPlans } from '../../models/transportation/vehicles-plan';
import { TransportationPlansService } from '../../services/transportation/transportation-plans.service';

@Component({
  selector: 'app-choose-transportation',
  templateUrl: './choose-transportation.component.html',
  styleUrls: ['./choose-transportation.component.scss']
})
export class ChooseTransportationComponent extends AppComponentBase implements OnInit {

  @Input() studentName!: string
  @Input() studentNationalId!: string

  transportationPlans: TransportationPlans[] | undefined = []

  constructor(injector: Injector, private modal: NgbModal, private transportationPlansService: TransportationPlansService,) { 
    super(injector)
  }

  ngOnInit(): void {
    this.getTransportationPlans()
  }

  closeModal() {
    this.modal.dismissAll()
  }

  getTransportationPlans() {
    this.transportationPlansService.getTransportationPlans().subscribe((transportationPlans: NotPaginatedTransportationPlans) => {
      this.transportationPlans = transportationPlans.data
    })
  }

  save() {}

}
